const sortDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export default sortDirection
